//import { Tabs } from "flowbite";
//import { initFlowbite } from "flowbite";
// import { readMoreButton } from "./components/readMoreButton";

function lazyLoadImages() {
  const images = document.querySelectorAll("img[data-src]");
  const pictures = document.querySelectorAll("source[data-srcset]");

  // Early return if no elements to observe
  if (images.length === 0 && pictures.length === 0) return;

  // Shared options for better performance
  const observerOptions = {
    rootMargin: '50px', // Start loading slightly before entering viewport
    threshold: 0.01     // Trigger as soon as 1% is visible
  };

  // Single callback for both images and sources
  const callback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;

        if (element.hasAttribute('data-src')) {
          element.src = element.dataset.src;
          delete element.dataset.src;
        } else if (element.hasAttribute('data-srcset')) {
          element.srcset = element.dataset.srcset;
          delete element.dataset.srcset;
        }

        observer.unobserve(element);
      }
    });
  };

  // Use single observer for both types
  const observer = new IntersectionObserver(callback, observerOptions);

  // Batch observe calls
  images.forEach((img) => observer.observe(img));
  pictures.forEach((pic) => observer.observe(pic));
}


function initNav() {
  const hamburgerIcon = document.getElementById('mobile-nav-toggle');
  const nav = document.querySelector('.nav-primary');
  const openMobileSearchButton = document.getElementById('open-mobile-search');
  const searchForm = document.getElementById('search-form');
  const searchInput = document.getElementById('search-input');

  // Early return if required elements don't exist
  if (!hamburgerIcon || !nav || !openMobileSearchButton || !searchForm || !searchInput) return;

  // Function to handle search toggle
  function toggleSearch(e) {
    e.preventDefault();

    // Use toggle() instead of manual add/remove
    const isHidden = searchForm.classList.toggle('hidden');
    searchForm.classList.toggle('flex', !isHidden);
    openMobileSearchButton.classList.toggle('hidden', !isHidden);

    if (!isHidden) {
      searchInput.focus();
    }
  }

  // Use single event listener (click handles touch on mobile)
  openMobileSearchButton.addEventListener('click', toggleSearch, { passive: false });

  searchForm.addEventListener('submit', function (e) {
    if (searchInput.value.length < 1) {
      e.preventDefault();
    }
  }, { passive: false });

  // Collapse search if not being used
  searchInput.addEventListener('blur', () => {
    if (!searchInput.value) {
      searchForm.classList.add('hidden');
      searchForm.classList.remove('flex');
      openMobileSearchButton.classList.remove('hidden');
    }
  }, { passive: true });

  // Toggle nav function
  function toggleNav() {
    nav.classList.toggle('fixed');
  }

  // Single event listener
  hamburgerIcon.addEventListener('click', toggleNav, { passive: true });
}


// window.addEventListener("load", function () {
//   // initSlider();
//   //initImageGalleryBlock();
//   readMoreButton();
//   //initFlowbite();
//   lazyLoadImages();
// });

window.addEventListener('load', async () => {
  if (document.querySelector('.guide-ckeditor .read-more-btn')) {
    import('./components/readMoreButton').then(({ readMoreButton }) => {
      readMoreButton();
    });
  }
  lazyLoadImages();
});

document.addEventListener('DOMContentLoaded', () => {
  initNav();
});